export const fixedIncomeAndStateProgarmRecordStrings = {
  strings: {
    en: {
      'PENS': 'Pensions',
      'SSEC': 'Social Security',
      'SSS': 'SSI, SSP, SSDI',
      'RETF': 'Retirement Accounts',
      'UNEM': 'Unemployment Benefits',
      'RRI': 'Rental or Royalty Income',
      'COI': 'Cash and/or other income',
      'WPSE': 'Wages and/or Profits from Self-Employment',
      'DWCP': 'Disability or Workers\u2019 Compensation Payments',
      'SGOI': 'Scholarships, Grant or other aid for living expenses',
      'ILST': 'Insurance or Legal Settlements',
      'SPCS': 'Spousal or Child Support',
      'ISSB': 'Interest / Dividends from Savings, Stocks, Bonds, or Retirement Accounts',
      'TANF': 'CalWorks(TANF) / Tribal TANF',
      'BIAG': 'Bureau of Indian Affairs General Assistance',
      'CFSN': 'CalFresh/SNAP (Food Stamps)',
      'HSIE': 'Head Start Income Eligible (Tribal Only)',
      'LIHE': 'Low-Income Home Energy Assistance Program',
      'MDCA': 'Medi-Cal/Medicaid',
      'MDCF': 'Medi-Cal for Families (Healthy Families)',
      'NSLP': 'National School Lunch Program (NSLP)',
      'SSI': 'Supplemental Security Income (SSI)',
      'WIC': 'Women, Infants, and Children (WIC)'
    },
    es: {
      'WIC': 'WIC',
      'LIHE': 'LIHEAP',
      'PENS': 'Pensiones',
      'SSEC': 'Seguridad Social',
      'SSS': 'SSI, SSP, SSDI',
      'RETF': 'Cuentas de jubilación',
      'UNEM': 'Beneficios de desempleado',
      'RRI': 'Pagos por discapacidad',
      'COI': 'Efectivo y / u otro ingreso',
      'WPSE': 'Salarios y / o beneficios del trabajo por cuenta propia',
      'DWCP': 'Pagos por Compensación por Discapacidad o Accidentes de Trabajo \u2019',
      'SGOI': 'Becas, subvenciones u otras ayudas para gastos de manutención',
      'ILST': 'Seguros o acuerdos legales',
      'SPCS': 'Conyugal o Manutención de los hijos',
      'ISSB': 'Intereses / Dividendos de Cuentas de Ahorro, Acciones, Bonos o de Retiro',
      'NSLP': 'Programa Nacional de Almuerzos Escolares (NSLP)',
      'BIAG': 'Oficina de Asistencia General de Asuntos Indígenas',
      'HSIE': 'Ingreso de Head Start Elegible (Sólo Tribal)',
      'MDCA': 'Medi - Cal / Medicaid',
      'SSI': 'Ingreso de Seguridad Suplementario (SSI)',
      'CFSN': 'Cal Fresh / SNAP (Food Stamps)',
      'TANF': 'CalWorks(TANF) / Tribal TANF',
    },
    zh: {
      'WIC': 'WIC',
      'LIHE': 'LIHEAP',
      'PENS': '养老金',
      'SSEC': '社会保障',
      'SSS': 'SSI, SSP, SSDI',
      'RETF': '退休账户',
      'UNEM': '失业救济金',
      'RRI': '租金或特许权收入',
      'COI': '现金和/或其他收入',
      'WPSE': '自营职业的工资和/或利润',
      'DWCP': '残疾人或工人补偿金',
      'SGOI': '奖学金，补助金或其他生活费援助',
      'ILST': '保险或者法律住区',
      'SPCS': '配偶或子女抚养费',
      'ISSB': '储蓄，股票，债券或退休账户的利息/股息',
      'NSLP': '全国学校午餐计划（NSLP）',
      'BIAG': '印度事务局一般援助局',
      'HSIE': 'Head Start Income Eligible（仅限部落）',
      'MDCA': 'Medi - Cal / Medicaid',
      'SSI': '补充保障收入（SSI）',
      'CFSN': 'Cal Fresh / SNAP (Food Stamps)',
      'TANF': 'CalWorks(TANF) / Tribal TANF',
    },
    ko: {
      'WIC': 'WIC',
      'LIHE': 'LIHEAP',
      'PENS': '연금',
      'SSEC': '사회 보장',
      'SSS': 'SSI, SSP, SSDI',
      'RETF': '퇴직 계정',
      'UNEM': '실업 급여',
      'RRI': '대여 또는 추가 수입',
      'COI': '현금 및 / 또는 기타 소득',
      'WPSE': '자기 고용으로 인한 임금 및 / 또는 이익',
      'DWCP': '장애 또는 근로자 보상 지급',
      'SGOI': '장학금, 생활비 보조 또는 기타 원조',
      'ILST': '보험 또는 법적 정착지 ',
      'SPCS': '배우자 또는 자녀 양육비',
      'ISSB': '저축, 주식, 채권 또는 은퇴 계좌의이자 / 배당금',
      'NSLP': '전국 학교 급식 프로그램 (NSLP)',
      'BIAG': '미국 원주민 국 일반 지원국',
      'HSIE': '자격 헤드 스타트 소득 (부족 만)',
      'MDCA': 'Medi - Cal / Medicaid',
      'SSI': '보충 보안 수입 (SSI)',
      'CFSN': 'CalFresh/SNAP (푸드 스탬프)',
      'TANF': 'CalWorks (TANF)/부족 TANF',
    },
    vi: {
      'WIC': 'WIC',
      'LIHE': 'LIHEAP',
      'PENS': 'Lương hưu',
      'SSEC': 'An ninh xã hội',
      'SSS': 'SSI, SSP, SSDI',
      'RETF': 'Tài khoản hưu trí ',
      'UNEM': 'Lợi ích thất nghiệp',
      'RRI': 'Cho thuê hoặc thu nhập bổ sung',
      'COI': 'Tiền mặt và / hoặc thu nhập khác',
      'WPSE': 'Tiền lương và / hoặc lợi nhuận từ việc tự làm',
      'DWCP': 'Thanh toán Bồi thường của Người lao động hoặc Người khuyết tật',
      'SGOI': 'Học bổng, trợ cấp hoặc viện trợ khác cho chi phí sinh hoạt',
      'ILST': 'Bảo hiểm hoặc thanh toán pháp lý',
      'SPCS': 'Hỗ trợ trẻ em hoặc vợ chồng',
      'ISSB': 'Lãi / Cổ tức từ Tiết kiệm, Cổ phiếu, Trái phiếu hoặc Tài khoản hưu tr',
      'NSLP': 'Chương trình ăn trưa trường quốc gia(NSLP)',
      'BIAG': 'Cục hỗ trợ chung về vấn đề người Mỹ bản xứ',
      'HSIE': 'Head Start Income Đủ điều kiện (Chỉ dành cho Bộ lạc)',
      'MDCA': 'Medi - Cal / Medicaid',
      'SSI': 'Thu nhập An sinh Bổ sung (SSI)',
      'CFSN': 'Cal Fresh / SNAP (Food Stamps)',
      'TANF': 'CalWorks(TANF) / Tribal TANF',
    }
  },
  common: []
};

